import '../scripts/security/styleNonceShim';
import $ from 'jquery';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import Toast from 'vue-toastification';
import App from './App.vue';
import router from './router';
import { bootstrapApp } from './app/bootstrap';
import { loadInitialData } from './app/initialLoader';
import '../styles/main.scss';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.jQuery = $;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.$ = $;

const initializeApp = async () => {
    const app = createApp(App);

    const pinia = createPinia();
    app.use(pinia);

    bootstrapApp();

    await loadInitialData();

    app.use(router);
    app.use(Toast);

    app.mount('#app');
};

initializeApp();
